import {
    FETCH_FAQS_REQUEST,
    FETCH_FAQS_SUCCESS,
    FETCH_FAQS_FAILURE,
    CREATE_FAQ_REQUEST,
    CREATE_FAQ_SUCCESS,
    CREATE_FAQ_FAILURE,
    UPDATE_FAQ_REQUEST,
    UPDATE_FAQ_SUCCESS,
    UPDATE_FAQ_FAILURE,
    ARCHIVE_FAQ_REQUEST,
    ARCHIVE_FAQ_SUCCESS,
    ARCHIVE_FAQ_FAILURE,
  } from "../actions/types";
  
  const initialState = {
    faqs: [],
    loading: false,
    error: null,
    message: "",
  };
  
  const faqReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_FAQS_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_FAQS_SUCCESS:
        return {
          ...state,
          loading: false,
          faqs: action.payload,
          message: "FAQs loaded successfully",
        };
  
      case FETCH_FAQS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          faqs: [],
        };
  
      case CREATE_FAQ_REQUEST:
        return { ...state, loading: true, error: null };
  
      case CREATE_FAQ_SUCCESS:
        return {
          ...state,
          loading: false,
          faqs: [...state.faqs, action.payload],
          message: "FAQ created successfully",
        };
  
      case CREATE_FAQ_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case UPDATE_FAQ_REQUEST:
        return { ...state, loading: true, error: null };
  
      case UPDATE_FAQ_SUCCESS:
        return {
          ...state,
          loading: false,
          faqs: state.faqs.map((faq) =>
            faq.faq_id === action.payload.faq_id ? action.payload : faq
          ),
          message: "FAQ updated successfully",
        };
  
      case UPDATE_FAQ_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case ARCHIVE_FAQ_REQUEST:
        return { ...state, loading: true, error: null };
  
      case ARCHIVE_FAQ_SUCCESS:
        return {
          ...state,
          loading: false,
          faqs: state.faqs.filter((faq) => faq.faq_id !== action.payload),
          message: "FAQ archived successfully",
        };
  
      case ARCHIVE_FAQ_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default faqReducer;
  